// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import VueScrollMonitor from 'vue-scrollmonitor';
import Vue2TouchEvents from 'vue2-touch-events';
import moment from 'moment';


import "babel-polyfill";

import Vue from 'vue';
import App from './App';
import router from './router';
import ga from './helpers/google-analytics';


Vue.filter('formatDate', function(value) {
  return (value) ? moment(String(value)).format('MMMM Do, YYYY') : '';
});

Vue.use(VueScrollMonitor);
Vue.use(Vue2TouchEvents);

Vue.config.productionTip = false;

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  template: '<App/>',
  components: { App },
});

ga.use(router);



// WEBPACK FOOTER //
// ./src/main.js